import mobile from "../../assets/images/mobile.png";
import ml from "../../assets/images/ml.png";
import blog from "../../assets/images/blog.png";

export const ProjectData = [
  {
    id: 1,
    image: mobile,
    title: "Bira Makeplay",
    category: "Mobile",
    link: "https://play.google.com/store/apps/details?id=com.bira91.makeplay",
  },
  {
    id: 2,
    image: mobile,
    title: "Starbucks India Compose",
    category: "Mobile",
    link: "https://github.com/Ruthvikbr/Starbucks-India-Compose",
  },
  {
    id: 3,
    image: mobile,
    title: "Notes app with Ktor backend",
    category: "Mobile",
    link: "https://github.com/Ruthvikbr/Android/tree/master/Ktor-Notes-App",
  },
  {
    id: 4,
    image: ml,
    title: "American Sign Language Converter",
    category: "Machine Learning",
    link: "https://github.com/Ruthvikbr/ASL",
  },
  {
    id: 5,
    image: blog,
    title: "Modern Android Development",
    category: "Blog",
    link: "https://mature-beard-511.notion.site/Modern-Android-Development-33b8483ad23640d38d2566dc8f93a6ce",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "Mobile",
  },
  {
    name: "Machine Learning",
  },
  {
    name: "Blog",
  },
];
